import { shallowReactive } from 'vue';

export class SearchManager {
    public SearchInput: string;
    public Search: string;
    private SearchTimeout?: ReturnType<typeof setTimeout>;

    constructor() {
        this.Search = " ";
        this.SearchInput = "";
    }

    public SetSearch() {
        clearTimeout(this.SearchTimeout);
        this.SearchTimeout = setTimeout(() => {
            this.Search = this.SearchInput
        }, 500);
    }
}

export default function GetSearchManager() {
    return shallowReactive(new SearchManager())
}
